import { UserNavigationComponent } from "../../../partials/navigation/user-navigation/user-navigation.component";
import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { HttpClient } from "@angular/common/http";
import { map, tap } from "rxjs/operators";
import * as jquery from 'jquery';

@Component({
  selector: 'app-marketing-collateral',
  templateUrl: './marketing-collateral.component.html',
  styleUrls: ['./marketing-collateral.component.scss']
})
export class MarketingCollateralComponent implements OnInit {

  activateSummary = true;
  activateSeriesOne = false;
  activateSeriesTwo = false;
  activateSeriesThree = false;
  activateSeriesFour = false;

  @ViewChild(UserNavigationComponent) userNavigation;

  constructor(
    private http: HttpClient,
    private userService: UserService,
  ) { }

  ngOnInit(): void {
    this.getUserProfile();

    var browserWidth = jquery(window).width();
    var leftPaneWidth = browserWidth/5;
    var leftPaneHeight = jquery(window).height() - 80;

    // Cache selectors
    var lastId,
      topMenu = jquery("#top-menu"),
      topMenuHeight = topMenu.outerHeight()+200,
      // All list items
      menuItems = topMenu.find("a"),
      // Anchors corresponding to menu items
      scrollItems = menuItems.map(function(){
        var item = jquery(jquery(this).attr("href"));
        if (item.length) { return item; }
      });


    // onload show first menu
    jquery('#menu_1_1').show();

    // Bind to scroll
    jquery(window).scroll(function() {

      // Get container scroll position
      var fromTop = jquery(this).scrollTop()+topMenuHeight;

      // Get id of current scroll item
      var cur = scrollItems.map(function(){
        if (jquery(this).offset().top < fromTop)
          return this;
      });
      // Get the id of the current element
      cur = cur[cur.length-1];
      var id = cur && cur.length ? cur[0].id : "";

      if (lastId !== id) {
        lastId = id;

        let activeContent = id.replace('series_', '');
                //jquery('#menu_'+activeContent+'').show();
        jquery('#menu_'+activeContent+'').fadeIn(700);

      }
    });
  }

  getUserProfile() {
    this.userService.getProfile()
      .pipe(
        // Get User Details
        map(user => user.data.user),
        tap(user => this.userNavigation.user = user),
      ).subscribe(
        response => {
      });
  }

  activateSeries(series) {
    switch (series) {      
      case 1: { this.activateSummary = false;
                this.activateSeriesOne = true;
                this.activateSeriesTwo = false;
                this.activateSeriesThree = false;
                this.activateSeriesFour = false;
                jquery('#bg_container').addClass( "series_1_menu" );
                jquery('#bg_container').removeClass( "summary_bg series_2_menu series_3_menu series_4_menu" );
                window.scrollTo(0,0);
                break;
              }
      case 2: { this.activateSummary = false;
                this.activateSeriesOne = false;
                this.activateSeriesTwo = true;
                this.activateSeriesThree = false;
                this.activateSeriesFour = false;
                jquery('#bg_container').addClass( "series_2_menu" );
                jquery('#bg_container').removeClass( "series_1_menu series_3_menu series_4_menu" );
                window.scrollTo(0,0);
                break;
              }
      case 3: { this.activateSummary = false;
                this.activateSeriesOne = false;
                this.activateSeriesTwo = false;
                this.activateSeriesThree = true;
                this.activateSeriesFour = false;
                jquery('#bg_container').addClass( "series_3_menu" );
                jquery('#bg_container').removeClass( "summary_bg series_1_menu series_2_menu series_4_menu" );
                window.scrollTo(0,0);
                break;
              }
      case 4: { this.activateSummary = false;
                this.activateSeriesOne = false;
                this.activateSeriesTwo = false;
                this.activateSeriesThree = false;
                this.activateSeriesFour = true;
                jquery('#bg_container').addClass( "series_4_menu" );
                jquery('#bg_container').removeClass( " series_1_menu series_2_menu series_3_menu" );
                window.scrollTo(0,0);
                break;
              }
      case 5: { this.activateSummary = true;
                this.activateSeriesOne = false;
                this.activateSeriesTwo = false;
                this.activateSeriesThree = false;
                this.activateSeriesFour = false;
                jquery('#bg_container').addClass( "summary_bg" );
                jquery('#bg_container').removeClass( "series_1_menu series_2_menu series_3_menu series_4_menu" );
                window.scrollTo(0,0);
                break;
              }
    }
  }

}
